import { z } from "zod";

export const OnboardingPriceBookItemSchema = z.object({
  Completed: z.boolean().optional(),
  SourceName: z.string().optional(),
  SourceCompleted: z.boolean().optional(),
  Reviewed: z.boolean().optional(),
  Uploaded: z.boolean().optional(),
  Copping: z.boolean().optional().optional(),
  VendorAdded: z.boolean().optional(),
});

export type OnboardingPriceBookItemType = z.infer<
  typeof OnboardingPriceBookItemSchema
>;
